module.exports = __webpack_public_path__ + "assets/img/jiachib_2013.140f8ff8.jpg";